import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://staging.api.schenck.one/acm',
  redirectUrl: 'https://so-acm-staging.azureedge.net/',
  clientId: 'f71495c7-2f49-462b-ac02-2cf37c0d027f',
  authority: 'https://login.microsoftonline.com/36515c62-8878-4f10-a7f4-561a4c17bef7',
  scope: 'api://f71495c7-2f49-462b-ac02-2cf37c0d027f/ACM.API',
};
